import { isEmpty, isNil } from 'lodash';
import { Chart, PageComponent } from '../../../models';

const CHART_EMBED_REGEX = /(@\[chart:[^\]]+\])/i;
const CHART_REFERENCE_REGEX = /@\[chart:([^\]]+)\]/i;
const PARAGRAPH_CHART_REFERENCE_REGEX = /<p>(@\[chart:[^\]]+\])<\/p>/gi;

const wrapInTableCell = (content) => `<td>${content}</td>`;
const wrapInTableRow = (content: string[], className?: string) => {
  return `<tr ${isEmpty(className) ? '' : `class="${className}"`}>${content.join('')}</tr>`;
};

const formatTable = (chart: Chart): string => {
  const rows = chart.aspects.map((aspect) => {
    const className = isNil(aspect.displayStyles) ? '' : aspect.displayStyles.join(' ').toLowerCase();
    const displayNameCell = wrapInTableCell(aspect.displayName);
    const dataCells = aspect.dataPoints.map((dataPoint) => wrapInTableCell(dataPoint.displayValue));
    return wrapInTableRow([displayNameCell, ...dataCells], className);
  });
  const tableBody = `<tbody>${rows.join('')}</tbody>`;

  const headerUnit = `<th>${chart.unitText}</th>`;
  const headerNames = chart.periods.map((period) => `<th>${period.displayName}</th>`);
  const tableHeader = `<thead>${wrapInTableRow([headerUnit, ...headerNames])}</thead>`;

  const table = `<table>${tableHeader}${tableBody}</table>`;
  const footnote = chart.footNote ? `<div class="table-footnote">${chart.footNote}</div>` : '';

  return `<div class="table-container">${table}${footnote}</div>`;
};

const formatDataCharts = (charts: Chart[] | null): Record<string, string> =>
  charts
    ? charts.reduce((acc, chart) => {
        acc[chart.reference] = formatTable(chart);
        return acc;
      }, {})
    : [];

export const formatComponentBody = ({ body, charts }: PageComponent): string => {
  const formattedDataCharts = formatDataCharts(charts);

  const splitBody = body
    .replace(PARAGRAPH_CHART_REFERENCE_REGEX, (match) => match.replace('<p>', '').replace('</p>', ''))
    .split(CHART_EMBED_REGEX)
    .map((segment) => {
      const referenceMatch = segment.match(CHART_REFERENCE_REGEX);
      if (!referenceMatch) {
        return segment;
      }

      return formattedDataCharts[referenceMatch[1]] || '';
    });

  return splitBody.join('');
};
